import React from "react";
import { useDispatch, useSelector } from "react-redux";
import TextareaAutosize from "react-textarea-autosize";
import { bookingNotificationFormAction } from "../../redux/rootReducer";
import { BOOKING_NOTIFICATION_FORM_INITIAL } from "../../redux/initialStateConstant";
import { sendBookingNotificationSagaAction } from "../../redux/sagaActions";

const BookingNotificationForm = () => {
    const dispatch = useDispatch();
    const bookingNotificationForm = useSelector(state => state.bookingNotificationForm);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => dispatch(bookingNotificationFormAction(BOOKING_NOTIFICATION_FORM_INITIAL)) }
                        />
                        <div className="form__title">Уведомления</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption">Заголовок</div>
                        <input type="text" className="input"
                            value={ bookingNotificationForm.title }
                            onInput={ event => dispatch(bookingNotificationFormAction({
                                ...bookingNotificationForm,
                                title: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Текст уведомления</div>
                        <TextareaAutosize
                            className="input input--textarea"
                            value={ bookingNotificationForm.message }
                            onInput={ event => dispatch(bookingNotificationFormAction({
                                ...bookingNotificationForm,
                                message: event.target.value
                            })) }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button"
                            onClick={ () => dispatch(sendBookingNotificationSagaAction({
                                booking_id: bookingNotificationForm.booking_id,
                                title: bookingNotificationForm.title,
                                message: bookingNotificationForm.message
                            })) }
                        >Отправить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BookingNotificationForm;